module.exports = __webpack_public_path__ + "img/partner 09.2de6d643.png";